import { Box, CircleIcon, ColorPalette, Flex } from '@shared/components';

export interface QuestionInLocationProps {
  statusColor: ColorPalette;
  content: React.ReactNode;
  highlight?: boolean;
  endAdornment?: React.ReactNode;
}

export default function QuestionInLocation(props: Readonly<QuestionInLocationProps>) {
  const { statusColor, content, highlight: isHighlight = false, endAdornment } = props;

  return (
    <Flex
      sx={(theme) => ({
        alignItems: 'center',
        justifyContent: 'space-between',
        p: theme.spacing(1, 1, 1, 2),
        backgroundColor: isHighlight ? theme.palette.grey[100] : 'inherit',
        borderRadius: isHighlight ? theme.shape.rounded(1) : 0,
        ':hover': {
          backgroundColor: theme.palette.grey[100],
          borderRadius: theme.shape.rounded(1),
        },
      })}
    >
      <Flex sx={{ alignItems: 'center', columnGap: (theme) => theme.spacing(2) }}>
        <CircleIcon
          sx={{
            color: (theme) =>
              Object.values(ColorPalette).includes(statusColor)
                ? theme.palette[statusColor].main
                : statusColor,
            width: '8px',
            height: '8px',
          }}
        />
        <Flex>{content}</Flex>
      </Flex>
      <Box sx={{ flexShrink: 0 }}>{endAdornment}</Box>
    </Flex>
  );
}
